// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3bmsU","requiredAsterisk":"Info_requiredAsterisk__BjfAJ"};